import { DisposalSet } from '@neptune/cx/utils';

// Workaround for a DXP 2026.Q1 page-editor bug (fixed upstream in LPD-103462); remove once AY's DXP includes it.
// See docs/tasks/page-editor-multi-select-stuck/INVESTIGATION.md.

const gc = new DisposalSet();

const releaseMultiSelect = () => {
    window.dispatchEvent(new KeyboardEvent('keyup', { key: 'Meta' }));
};

if (document.body.classList.contains('has-edit-mode-menu')) {
    (gc.register(window)
        .addListener('mousedown', (event) => {
            if (!event.metaKey && !event.ctrlKey && !event.shiftKey) {
                releaseMultiSelect();
            }
        }, true)
        .addListener('blur', releaseMultiSelect)
    );
}

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
